module.exports = __webpack_public_path__ + "img/3-off.665af5d1.png";